import { notification } from 'antd';
import actions from './actions';
import { QUERY } from './query';
import { DataService } from '../../config/dataService/dataService';

const addNotificationSuccess = () => {
  notification.success({
    message: 'Country Added Successfully!',
  });
};

const addNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const deleteNotificationSuccess = () => {
  notification.success({
    message: 'Country has been Deleted',
  });
};

const deleteNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const updateNotificationSuccess = () => {
  notification.success({
    message: 'Country has been updated',
  });
};

const updateNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const {
  AddCountryBegin,
  AddCountrySuccess,
  AddCountryErr,

  getCountriesBegin,
  getCountriesSuccess,
  getCountriesErr,

  UpdateCountryBegin,
  UpdateCountrySuccess,
  UpdateCountryErr,

  DeleteCountryBegin,
  DeleteCountrySuccess,
  DeleteCountryErr,
} = actions;

const DataSubmit = (data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(AddCountryBegin());
      const response = await DataService.gql(QUERY.addCountry(data));
      const token = localStorage.getItem('access_token');
      if (token) {
        await dispatch(AddCountrySuccess(response.data.data));
        addNotificationSuccess();
        callback(true);
      } else {
        await dispatch(AddCountryErr('No Unauthorize access'));
        addNotificationError('No Unauthorize access');
      }
    } catch (err) {
      await dispatch(AddCountryErr('Something went wrong, Unable to create Country.'));
      addNotificationError('Something went wrong, Unable to create Country.');
    }
  };
};

const DataRead = () => {
  return async (dispatch) => {
    try {
      await dispatch(getCountriesBegin());
      const query = await DataService.gql(QUERY.allCountries);
      const token = localStorage.getItem('access_token');
      if (token) {
        await dispatch(getCountriesSuccess(query.data.data.allMasterCountries.nodes));
      } else {
        await dispatch(AddCountryErr('No Unauthorize access'));
        addNotificationError('No Unauthorize access');
      }
    } catch (err) {
      await dispatch(getCountriesErr(err));
    }
  };
};

const DataSearch = (searchItem) => {
  return async (dispatch) => {
    try {
      await dispatch(getCountriesBegin());
      if (searchItem !== '') {
        const query = await DataService.get(`/data/search/${searchItem}`);
        await dispatch(getCountriesSuccess(query.data.data));
      } else {
        try {
          const query = await DataService.get('/data/all');
          await dispatch(getCountriesSuccess(query.data.data));
        } catch (err) {
          await dispatch(getCountriesErr(err));
        }
      }
    } catch (err) {
      await dispatch(getCountriesErr(err));
    }
  };
};

const DataUpdate = (id, data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(UpdateCountryBegin());
      await DataService.gql(QUERY.updateCountry({ id, ...data }));
      await dispatch(UpdateCountrySuccess());
      updateNotificationSuccess();
      callback(true);
    } catch (err) {
      await dispatch(UpdateCountryErr(err));
      updateNotificationError(err);
    }
  };
};

const DataDelete = ({ id, getData }) => {
  return async (dispatch) => {
    try {
      await dispatch(DeleteCountryBegin());
      const data = await DataService.gql(QUERY.updateCountry({ id, isActive: false }));

      await dispatch(DeleteCountrySuccess(data.data));
      await getData();
      deleteNotificationSuccess();
    } catch (err) {
      await dispatch(DeleteCountryErr(err));
      deleteNotificationError(err);
    }
  };
};

export { DataRead, DataSearch, DataSubmit, DataDelete, DataUpdate };
